type TMonthDay = {
  day: number;
  month: number;
  weekDay: number;
  year: number;
};

type TMonthDays = Array<TMonthDay | null>;

type TWeekDay = {
  weekday: number;
  isWeekend: boolean;
};

type TWeekStart = 0 | 1;

enum ECalendarType {
  DATE = 'DATE',
  DATE_RANGE = 'DATE_RANGE',
}

type TCalendarType = keyof typeof ECalendarType;

type TValue = Date;

type TRangeValue = {
  startDate: Date | null;
  endDate: Date | null;
};

type TCalendarDate = TValue | TRangeValue;

type THoveredStatus = {
  isHovered: boolean;
  isStartHovered: boolean;
  isEndHovered: boolean;
};

enum ECalendarPeriod {
  MONTH = 'MONTH',
  YEAR = 'YEAR',
  DECADE = 'DECADE',
}

enum ECalendarLeadDate {
  START = 'START',
  END = 'END',
}

const YEARS_IN_DECADE = 10;

export {ECalendarType, ECalendarPeriod, ECalendarLeadDate, YEARS_IN_DECADE};

export type {
  TCalendarDate,
  TValue,
  TRangeValue,
  TCalendarType,
  TWeekStart,
  TWeekDay,
  TMonthDays,
  TMonthDay,
  THoveredStatus,
};
